import { render, staticRenderFns } from "./ActionOpenChatInstant.vue?vue&type=template&id=2baca6da"
import script from "./ActionOpenChatInstant.vue?vue&type=script&lang=js"
export * from "./ActionOpenChatInstant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports